import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BasicTooltip, ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Button, TextField, Typography, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAllocationUtilityStyles from '../../AllocationUtility/styles';
const SubmeterChargesErrorsTable = observer(_ref => {
  let chargeErrors = _ref.chargeErrors;
  const classes = useAllocationUtilityStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(10),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    rows = _useState4[0],
    setRows = _useState4[1];
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign && classes.rightAlign
  }, text);
  const renderCellTooltip = (parameter, left) => /*#__PURE__*/React.createElement("div", {
    className: classes.overflowCellWrapper
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: parameter,
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.overflowCell
  }, parameter))));
  useEffect(() => {
    setRows(chargeErrors || []);
  }, [chargeErrors]);
  const columns = [{
    field: 'info',
    align: 'center',
    width: 74,
    sortable: false,
    renderCell: () => {
      return /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "error",
        title: "Errors during posting custom charge...",
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        type: "warning",
        state: "error"
      })));
    },
    renderHeader: () => renderHeader('')
  }, {
    field: 'number',
    align: 'right',
    flex: 1,
    maxWidth: 80,
    headerName: 'Unit name',
    renderCell: params => renderCellTooltip(params.row.number, true),
    renderHeader: () => renderHeader(t('allocations.unit_name')),
    sortComparator: (v1, v2) => {
      var _ref2;
      return (_ref2 = '' + v1) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(v2, undefined, {
        numeric: true
      });
    }
  }, {
    field: 'name',
    align: 'left',
    flex: 1,
    headerName: 'Account name',
    minWidth: 190,
    maxWidth: 250,
    renderCell: params => renderCellTooltip(params.row.name, true),
    renderHeader: () => renderHeader('Account Name')
  }, {
    field: 'title',
    align: 'right',
    flex: 1,
    minWidth: 460,
    headerName: 'Transaction title',
    headerAlign: 'left',
    renderCell: params => renderCellTooltip(params.row.title, true),
    renderHeader: () => renderHeader('Description')
  }, {
    field: 'amount',
    align: 'right',
    flex: 1,
    maxWidth: 100,
    headerAlign: 'right',
    headerName: 'Charge amount',
    renderCell: params => /*#__PURE__*/React.createElement("div", {
      className: classes.cellContent
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "$", Number(params.row.amount).toFixed(2))),
    renderHeader: () => renderHeader('Charge amount', true)
  }];
  return /*#__PURE__*/React.createElement(DataGrid, {
    autoHeight: true,
    columns: columns,
    disableRowSelectionOnClick: true,
    getRowClassName: () => classes.row,
    getRowId: row => row.userAccountId,
    rowsPerPageOptions: [5, 10, 20],
    onPageSizeChange: newPageSize => setPageSize(newPageSize),
    pagination: true,
    columnHeaderHeight: 95,
    rowHeight: 77,
    hideFooterSelectedRowCount: true,
    initialState: {
      sorting: {
        sortModel: [{
          field: 'name',
          sort: 'asc'
        }]
      }
    },
    pageSize: pageSize,
    rows: rows,
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    slots: {
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton",
        'custom-attribute': '501-Submeter-charges-errors-table'
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      }))
    }
  });
});
export default SubmeterChargesErrorsTable;